import PreviewCategories from "./PreviewCategories";

export default PreviewCategories;
